// Collapsible mobile menu that shows the header

export default class ExpandActiveParent {
	constructor() {
		this.menu = document.querySelector(".sidebar-navigation");
		this.activeLinks = document.querySelectorAll(".sidebar-navigation a.active");
		
		if (this.menu) {
			this.run();
		}
	}

	run() {
		this.activeLinks.forEach(a => {
			const buttons = [];
			do {
				const button = a.parentElement.querySelector('button[aria-expanded="false"]');
				if (button) {
					buttons.push(button);
				}
				a = a.parentElement;
			} while ( ! a.parentElement.isEqualNode(this.menu));
			
			buttons.reverse().forEach(button => {
				button.attributes['aria-expanded'].value = true;
			});
		});
	}
}